<template>
  <div>
    <h2>
      {{ $t('pageLinks.debug') }}
    </h2>
    <div>
      {{ $t('debug.warning') }}
    </div>
    <div class="mt-3">
      {{ $t('debug.sendToMyFigb') }}
      <b-button-group>
        <b-input v-model="messageToMyFigb"></b-input>
        <b-button @click="sendMessageToMyFigb" variant="primary">{{ $t('debug.send') }}</b-button>
      </b-button-group>
    </div>
    <div class="mt-3">
      {{ $t('debug.recognizerTest') }}<br>
      {{ recognizedCards }}<br>
      <video ref="webcam"></video>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'Debug',
  data() {
    return {
      messageToMyFigb: "REG#posizione al tavolo non corretta, necessario ripristino della connessione eseguendo nuovamente la registrazione",
      initialized_model: null,
      rawRecognizedCards: []
    };
  },
  computed: {
    ...mapGetters({
      deals: 'deals/played',
    }),
    boardsNumber() {
      return this.deals.map(deal => deal.number);
    },
    recognizedCards() {
      return [...new Set(this.rawRecognizedCards
          .filter(c => c.confidence > 0.6)
          .map(c => c.class))];
    }
  },
  methods: {
    sendMessageToMyFigb() {
      window.parent.postMessage(this.messageToMyFigb, '*');
    },
  },
  mounted() {
// eslint-disable-next-line no-undef
    const stoca = roboflow;

    const video = this.$refs["webcam"];

    navigator.mediaDevices.getUserMedia({video: true})
        .then(function (stream) {
          video.srcObject = stream;
          video.play();
        })
        .catch(function (err) {
          console.error('Errore durante l\'accesso alla webcam: ', err);
        });

    async function getModel() {

      return stoca.auth({
        publishable_key: "rf_cqzVt9BjRNbZnPrR8Oglm8sVnn93"
      }).load({
        model: "playing-cards-ow27d",
        version: 4
      });
    }

    this.initialized_model = getModel();

    const that = this;

    this.initialized_model.then(function (model) {
      setInterval(function () {
        model.detect(video).then(function (predictions) {
          that.rawRecognizedCards = predictions;
        });
      }, 200);
    });
  }
};
</script>

<style scoped>
</style>
